enum BlockType {
  UNKNOWN = -1,
  HEADER = 1,
  HEADER_WITH_LOGO = 2,
  HEADER_LOGO_MENU = 3,
  HEADER_FREE = 4,
  HEADER_WITH_LOGO_FREE = 5,
  HEADER_LOGO_MENU_FREE = 6,
  TITLE = 10,
  IMAGE = 11,
  TXT_BACKGROUND = 12,
  TXT_BACKGROUND_TALL = 40,
  IMAGE_TEXT = 13,
  MENU_LIST_3 = 14,
  MAP = 15,
  TEXT = 16,
  TEXT_LIST = 17,
  BUTTON = 18,
  HTML = 19,
  CARD_LEFT = 20,
  CARD_RIGHT = 21,
  CARD_LEFT_CENTERED = 22,
  CARD_RIGHT_CENTERED = 23,
  TITLE_TXT_BUTTON = 24,
  TITLE_TXT_BUTTON_TALL = 41,
  BUTTON_LIST = 25,
  CAROUSEL = 26,
  CAROUSEL_TALL = 45,
  CAROUSEL_FIXED = 48,
  CAROUSEL_FIXED_TALL = 49,
  IMAGE_LIST = 27,
  TABLE = 28,
  TABLE_BOTTOM_BORDER = 29,
  TABLE_NO_BORDER = 30,
  CENTERED_IMAGE = 31,
  FULL_BLEED_IMAGE = 32,
  FULL_BLEED_CARD_LEFT_CENTERED = 33,
  FULL_BLEED_CARD_RIGHT_CENTERED = 39,
  LINED_TITLE = 34,
  I_FRAME = 35,
  SNS_OLD = 36,
  SNS = 37,
  ANIMATION_COMPONENT = 38,
  ANIMATION_WITH_DESCRIPTION_COMPONENT = 44,
  CONTACT = 42,
  VIDEO = 43,
  BLOCK_MENU_LIST_WITH_COLUMNS = 46,
  BLOCK_MENU_LIST_WITH_EQUAL_SPACE = 47,
  HTML_SAFE = 50,
  I_FRAME_SAFE = 51,
  BLOCK_MENU_LIST_FIXED_MAX_2 = 52,
  BLOCK_MENU_LIST_FIXED_MAX_3 = 53,
  BLOCK_MENU_LIST_FIXED_MOBILE_2 = 54,
  BLOCK_MENU_LIST_EQUAL_MOBILE_2 = 55,
  I_FRAME_SERVICES = 56,
  BLOCK_MENU_LIST_EQUAL_MAX_2 = 57,
  BLOCK_MENU_LIST_EQUAL_MAX_3 = 58,
  FOOTER = 99,
  FOOTER_FREE = 98,
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockType {
  export function describe(blockType: BlockType): string {
    switch (blockType) {
      case BlockType.HEADER: return 'ヘッダー';
      case BlockType.HEADER_WITH_LOGO: return 'ヘッダー＋ロゴ';
      case BlockType.HEADER_LOGO_MENU: return 'ロゴ＋メニュー';
      case BlockType.HEADER_FREE: return 'メニュー';
      case BlockType.HEADER_WITH_LOGO_FREE: return 'メニュー＋ロゴ';
      case BlockType.HEADER_LOGO_MENU_FREE: return 'ロゴ＋メニューセット';
      case BlockType.TITLE: return 'タイトル';
      case BlockType.IMAGE: return '画像';
      case BlockType.TXT_BACKGROUND: return 'テキスト＋背景画像';
      case BlockType.TXT_BACKGROUND_TALL: return 'テキスト＋背景画像（高さ大）';
      case BlockType.IMAGE_TEXT: return '画像＋テキスト';
      case BlockType.MENU_LIST_3: return 'メニューリスト×列';
      case BlockType.MAP: return '地図';
      case BlockType.TEXT: return '文章';
      case BlockType.TEXT_LIST: return '文章x列';
      case BlockType.BUTTON: return 'ボタン';
      case BlockType.HTML: return '(旧) HTML';
      case BlockType.CARD_LEFT: return 'タイトル＋文章＋左画像';
      case BlockType.CARD_RIGHT: return 'タイトル＋文章＋右画像';
      case BlockType.CARD_LEFT_CENTERED: return '文章＋左画像';
      case BlockType.CARD_RIGHT_CENTERED: return '文章＋右画像';
      case BlockType.TITLE_TXT_BUTTON: return 'タイトル＋文書＋ボタン';
      case BlockType.TITLE_TXT_BUTTON_TALL: return 'タイトル＋文書＋ボタン（高さ大）';
      case BlockType.BUTTON_LIST: return 'ボタンセット';
      case BlockType.CAROUSEL: return 'スライダー';
      case BlockType.CAROUSEL_TALL: return 'スライダー（高さ大）';
      case BlockType.CAROUSEL_FIXED: return 'スライダー（固定比率）';
      case BlockType.CAROUSEL_FIXED_TALL: return 'スライダー（固定比率・高さ大）';
      case BlockType.IMAGE_LIST: return '画像ボタン';
      case BlockType.TABLE: return '表';
      case BlockType.TABLE_BOTTOM_BORDER: return '表（下線のみ）';
      case BlockType.TABLE_NO_BORDER: return '表（線なし）';
      case BlockType.CENTERED_IMAGE: return '上画像';
      case BlockType.FULL_BLEED_IMAGE: return '画像（フルサイズ）';
      case BlockType.FULL_BLEED_CARD_LEFT_CENTERED: return '左フル画像';
      case BlockType.FULL_BLEED_CARD_RIGHT_CENTERED: return '右フル画像';
      case BlockType.LINED_TITLE: return '二重線（上下）';
      case BlockType.I_FRAME: return '(旧) iFrame';
      case BlockType.SNS_OLD: return 'SNS_OLDブロック';
      case BlockType.SNS: return 'SNSブロック';
      case BlockType.ANIMATION_COMPONENT: return 'アニメーションコンポネート';
      case BlockType.ANIMATION_WITH_DESCRIPTION_COMPONENT: return '説明付きアニメーションコンポーネント';
      case BlockType.CONTACT: return 'お問合せ';
      case BlockType.FOOTER: return 'フッター';
      case BlockType.FOOTER_FREE: return 'メニュー＋テキスト';
      case BlockType.BLOCK_MENU_LIST_WITH_COLUMNS: return 'メニューリスト×列【固定幅】';
      case BlockType.BLOCK_MENU_LIST_WITH_EQUAL_SPACE: return 'メニューリスト×列【等間隔】';
      case BlockType.BLOCK_MENU_LIST_FIXED_MAX_2: return 'メニューリスト×列【固定幅 最大２列】(スマホ２列)';
      case BlockType.BLOCK_MENU_LIST_FIXED_MAX_3: return 'メニューリスト×列【固定幅 最大３列】(スマホ２列)';
      case BlockType.BLOCK_MENU_LIST_FIXED_MOBILE_2: return 'メニューリスト×列【固定幅】（スマホ２列）';
      case BlockType.BLOCK_MENU_LIST_EQUAL_MOBILE_2: return 'メニューリスト×列【等間隔】（スマホ２列）';
      case BlockType.BLOCK_MENU_LIST_EQUAL_MAX_2: return 'メニューリスト×列【等間隔 最大２列】(スマホ２列)';
      case BlockType.BLOCK_MENU_LIST_EQUAL_MAX_3: return 'メニューリスト×列【等間隔 最大３列】(スマホ２列)';
      case BlockType.VIDEO: return '動画';
      case BlockType.HTML_SAFE: return 'HTML';
      case BlockType.I_FRAME_SAFE: return 'iFrame';
      case BlockType.I_FRAME_SERVICES: return 'GoogleMap・Youtube・Instagram';
      default: return '（未登録）';
    }
  }
}

export default BlockType;
